import { GenericManageAdminPage } from '~/components/GenericManageAdminPage/GenericManageAdminPage';
import { useCreateClubAdminMutation, useDeleteClubAdminMutation } from '../mutations';
import { useAuthentication } from '~/hooks/useAuthentication';
import { useClubAdminListQuery } from '../queries';
import { useParams } from '~/hooks/useParams';
import { idParamSchema } from '~/schemas';

export function Page() {
  const { id } = useParams(idParamSchema.parse);
  const { can } = useAuthentication();

  const removeMutation = useDeleteClubAdminMutation();
  const createMutation = useCreateClubAdminMutation();
  const query = useClubAdminListQuery(id);

  return (
    <GenericManageAdminPage
      showCreate={can('create-club-admin', id)}
      showRemove={can('delete-club-admin', id)}
      title="Föreningsadministratörer"
      removeMutation={removeMutation}
      createMutation={createMutation}
      entityId={id}
      query={query}
    />
  );
}
